import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWaterSystem } from '../../types';
import {
  fetchWaterSystemsAsync,
  fetchPublicWaterSystemsByAddressAsync,
  fetchWaterSystemsAsyncBuilder, fetchPublicWaterSystemsByAddressAsyncBuilder,
} from './asyncRequests'
import { fetchPublicWaterSystemsByAddressComponentAsync } from './asyncRequests/fetchPublicWaterSystemsByAddressComponentAsync';

export interface IZipCenter {
  coordinates: { lat: number; lng: number }
  zip: string;
}

export interface IWaterSystemsData{
  zipCenter: IZipCenter[]
  waterSystems: IWaterSystem[]
}

export enum WaterSystemType {
  PUBLIC = 'public',
  WELL = 'well'
}

export interface WaterSystemsInitialState {
  data: IWaterSystemsData
  loading: boolean;
  error: string;
  success: boolean;
  userSearched: boolean
  selectedWaterSystem: any
  selectedSystemType: WaterSystemType
}

const initialState: WaterSystemsInitialState = {
  data: {} as IWaterSystemsData,
  loading: false,
  error: '',
  success: false,
  userSearched: false,
  selectedWaterSystem: null,
  selectedSystemType: WaterSystemType.PUBLIC
};

export const WaterSystemsSlice = createSlice({
  name: 'waterSystemsSlice',
  initialState,
  reducers: {
    setUserSearched: (state, action) => {
      state.userSearched = action.payload;
    },
    setSelectedWaterSystem: (state, action: PayloadAction<string | null>) => {
      state.selectedWaterSystem = action.payload;
    },
    setSelectedSystemType: (state, action: PayloadAction<WaterSystemType>) => {
      state.selectedSystemType = action.payload;
    },
    resetWaterSystemsData: (state) => {
      state.data = initialState.data
    }
  },
  extraReducers: (builder) => {
    fetchWaterSystemsAsyncBuilder(builder);
    fetchPublicWaterSystemsByAddressAsyncBuilder(builder)
  },
});

export const WaterSystemsActions = {
  ...WaterSystemsSlice.actions,
  fetchWaterSystemsAsync,
  fetchPublicWaterSystemsByAddressAsync,
  fetchPublicWaterSystemsByAddressComponentAsync,
};

export const WaterSystemsReducer = WaterSystemsSlice.reducer;